import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import {
  IncludedItemSelector,
  ManageItemsInBundleForm,
} from '@/features/admin/bundle/components/ManageItemsInBundleForm'
import { type ManageItemsInBundleViewModel } from './ManageItemsInBundleViewModel'
import { type IncludedItemViewModel } from './IncludedItemViewModel'

export interface ManageItemsInBundleFormContainerProps {
  vm: ManageItemsInBundleViewModel
}

export const ManageItemsInBundleFormContainer = observer(
  function ManageItemsInBundleFormContainer({
    vm,
  }: ManageItemsInBundleFormContainerProps) {
    const testId = 'bundle-included-items-modal'
    const itemTestId = 'bundle-included-item-modal'

    return (
      <ManageItemsInBundleForm
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        searchText={vm.searchText.value}
        onSearchTextChange={vm.searchText.change}
        totalSelected={vm.totalSelected}
        onSubmit={vm.submit}
        testId={testId}
        loader={
          !vm.inventoryScrollProvider.isDone && (
            <InfiniteScrollLoaderContainer
              scrollProvider={vm.inventoryScrollProvider}
            />
          )
        }
      >
        {vm.serviceItems.map((includedItemVm) => (
          <IncludedItemSelectorContainer
            key={includedItemVm.inventoryItemId}
            includedItemVm={includedItemVm}
            manageIncludedItemsVm={vm}
            testId={itemTestId}
          />
        ))}
      </ManageItemsInBundleForm>
    )
  },
)

interface IncludedItemSelectorContainerProps {
  manageIncludedItemsVm: ManageItemsInBundleViewModel
  includedItemVm: IncludedItemViewModel
  testId?: string
}

const IncludedItemSelectorContainer = observer(
  function IncludedItemSelectorContainer({
    manageIncludedItemsVm,
    includedItemVm,
    testId,
  }: IncludedItemSelectorContainerProps) {
    return (
      <IncludedItemSelector
        name={includedItemVm.name}
        description={includedItemVm.description}
        isIncludedItem={includedItemVm.isIncludedItem}
        onToggleIncludedItem={includedItemVm.toggleIncludedItem}
        isBaseItem={includedItemVm.isBaseItem}
        onToggleBaseItem={includedItemVm.toggleBaseItem}
        isBaseItemDisabled={manageIncludedItemsVm.isBaseItemDisabled(
          includedItemVm,
        )}
        testId={testId}
      />
    )
  },
)
